/**
 * Example usage:
 *   margin-left: ${withCssUnit(8)}
 *   =
 *   margin-left: 8px
 *
 *   margin-left: ${withCssUnit(0)}
 *   =
 *   margin-left: 0
 *
 * @param value
 * @param unit
 * @param fallbackValue
 * @return {string|string}
 */
const withCssUnit = (value, unit = "px", fallbackValue = "0") => {
  if (!unit) {
    throw new Error("CSS unit cannot be null.");
  }

  return value ? `${value}${unit}` : fallbackValue;
};

export default withCssUnit;
